<template>
  <section class="app-main">
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <router-view />
    </transition>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { toasts } from '@/utils/toasts'

@Component({
  name: 'App'
})
export default class extends Vue {
  created(): void {
    toasts.observable
      .subscribe(([message, options]) => {
        this.$bvToast.toast(message, options)
      })
  }
}
</script>

<style lang="scss">
</style>
